import apiClient from "./apiClient";
import API_CONFIG from "../config/apiconfig";

const PREVIEW_INFO_URL = `${API_CONFIG.baseURL}api/DocumentPreview/Info`;
const PREVIEW_ENQUEUE_URL = `${API_CONFIG.baseURL}api/DocumentPreview/Enqueue`;
// Inline stream: GET api/DocumentPreview/Inline?url=...&fileName=... (used by DocumentPreviewPane)

export async function fetchDocumentPreviewInfo({ sourceModule, documentId }) {
  const res = await apiClient.post(PREVIEW_INFO_URL, {
    SourceModule: sourceModule,
    DocumentId: documentId,
  });
  const body = res?.data ?? res;
  const payload = body?.data ?? body;
  return {
    success: Number(body?.success ?? 0) === 1,
    message: body?.message || "",
    info: payload || null,
  };
}

export async function enqueueDocumentPreview(payload) {
  const res = await apiClient.post(PREVIEW_ENQUEUE_URL, {
    SourceModule: payload.sourceModule,
    SourceTable: payload.sourceTable,
    DocumentId: payload.documentId,
    BlobUrl: payload.blobUrl,
    FileExtension: payload.fileExtension,
    Priority: payload.priority ?? 100,
  });
  const body = res?.data ?? res;
  return {
    success: Number(body?.success ?? 0) === 1,
    message: body?.message || "",
    data: body?.data ?? null,
  };
}
